import React from 'react';

const Icon = () => {
    return (
        <div
            style={{
                borderWidth: 1,
            }}
            className="w-20 h-20 lg:w-20 lg:h-20 rounded-full flex justify-center items-center"
        >
            <svg
                className="w-8 h-8"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"
                ></path>
            </svg>
        </div>
    );
};

export default Icon;
